/**
 * Supported locale codes (ISO 639-1) for i18n and tenant platform language.
 * Must match backend locale constants.
 */
export const SUPPORTED_LOCALES = ['it', 'en', 'es', 'fr'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'it';

export const LOCALE_IT: Locale = 'it';
export const LOCALE_EN: Locale = 'en';
export const LOCALE_ES: Locale = 'es';
export const LOCALE_FR: Locale = 'fr';

export const LOCALE_LABELS: Record<Locale, string> = {
  it: 'Italiano',
  en: 'English',
  es: 'Español',
  fr: 'Français',
};
